<template>
  <div>
    <v-card max-width="1600" max-height="80%" v-if="pago">
      <v-card-title>
        <h4>
          SIAPA - {{ pago.medioPago.nombre }} - ID: {{ pago.id }}
          {{ pago.fechaApertura | formatDate }} - {{ pago.estado }}
        </h4>
      </v-card-title>
      <v-card-text>
        <v-container
          id="scroll-target"
          class="overflow-y-auto"
          style="max-height: 800px; max-width: 1500px"
          ref="contenido"
        >
        <v-progress-linear
            indeterminate
            rounded
            :active="loading"
          ></v-progress-linear>

          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-right">Gen</th>
                  <th class="text-right">OP</th>
                  <th class="text-left">Cedula</th>
                  <th class="text-left">Nombres</th>
                  <th class="text-right">Numero Factura</th>
                  <!-- <th class="text-right">Monto Factura</th> -->
                  <th class="text-left">Cuenta</th>
                  <th class="text-right">Monto OP</th>
                  <th class="text-right">Estado</th>
                  <th class="text-left"></th>
                  <th class="text-left" v-if="pago.estado == 'Abierto'"></th>
                  <th class="text-left"></th>
                  <th class="text-left"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="detalle in pago.pagosDetalle" :key="detalle.id">
                  <td>
                    {{ detalle.ordenPago.generacion.nombreCorto }}
                  </td>
                  <td>
                    {{ detalle.ordenPago.id }}
                  </td>
                  <td>

                      {{ detalle.ordenPago.titular.cedula }}
                      <!-- <ActualizarCedula
                        v-if="pago.estado == 'Abierto'"
                        @nuevaCedula="nuevaCedula"
                        :id="detalle.ordenPago.beneficiario.id"
                        :cedula="detalle.ordenPago.beneficiario.cedula"
                      /> -->

                  </td>
                  <td>
                    {{
                      detalle.ordenPago.titular.nombres +
                      " " +
                      detalle.ordenPago.titular.apellidos
                    }}
                  </td>
                  <td>
                    <v-layout fluid align-center justify-end>
                      <div v-if="detalle.factura">
                        {{ detalle.factura.numeroFactura }}
                      </div>
                      <ActualizarFactura
                        :ordenPagoId="detalle.ordenPago.id"
                        :pagoDetalleId="detalle.id"
                        @nuevaFactura="nuevaFactura"
                        v-if="pago.estado == 'Abierto'"
                      />
                    </v-layout>
                  </td>
                  <!-- <td class="text-right">
                    <div v-if="detalle.factura">
                      {{ detalle.factura.montoFactura | numberFormat }}
                    </div>
                  </td> -->
                  <td>
                      Banco: {{ detalle.banco ? detalle.banco.descripcion : 'SIN CODIGO DE BANCO: '  + (detalle.ordenPago.titular.formaCobro ? detalle.ordenPago.titular.formaCobro : " sin forma cobro") }} <br>
                      Nro. Cuenta: {{ detalle.cuenta }}<br/>
                      Titular: {{ detalle.nombreTitularCuenta}} <br/>
                      Doc: {{ detalle.tipoDocumentoCuenta}} {{ detalle.numeroDocumentoCuenta}} <br/>
                      

                      <!-- <ActualizarCuenta
                        v-if="pago.estado == 'Abierto'"
                        @nuevaCuenta="nuevaCuenta"
                        :id="detalle.id"
                        :cuenta="detalle.cuenta"
                      /> -->
                  </td>


                  <td class="text-right">
                    <v-layout fluid align-center justify-end>
                      {{ detalle.monto | numberFormat }}
                      <ActualizarMonto
                        v-if="pago.estado == 'Abierto'"
                        @nuevoMonto="nuevoMonto"
                        :id="detalle.id"
                        :monto="detalle.monto"
                      />
                    </v-layout>
                  </td>
                  <td>
                    <v-chip :class="`${detalle.estado}  my-2 caption`">{{
                      detalle.estado
                    }}</v-chip>
                  </td>
                  <td>
                    <v-btn
                      small
                      color="info"
                      v-if="pago.estado == 'Abierto'"
                      @click="eliminarDetalle(detalle.id)"
                      >Eliminar</v-btn
                    >
                  </td>
                  <!-- <td><v-btn small color="primary" v-if="pago.estado=='Validado'">Anular</v-btn></td> -->
                  <td>
                    <ConfirmarDescripcion
                      @anulacionConfirmada="anular"
                      titulo="Motivo de la anulacion"
                      :id="detalle.id"
                      v-if="
                        pago.estado == 'Validado' &&
                        detalle.estado == 'Pendiente'
                      "
                    />
                  </td>
                </tr>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <td class="text-right font-weight-bold">
                  {{ total | numberFormat }}
                </td>
                <td class="text-right"></td>
                <td class="text-left"></td>
                <td class="text-left"></td>
                <tr></tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="volver">Volver</v-btn>
        <AgregarDetalle
          @agregarDetalle="agregarDetalle"
          @agregarDetalleMasivo="agregarDetalleMasivo"
          v-if="pago.estado == 'Abierto'"
        />
        <v-spacer></v-spacer>
        <!-- <v-btn color="warning" v-if="pago.estado == 'Abierto'" @click="validar">Validar</v-btn> -->
        <Confirmar
          v-if="pago.estado == 'Abierto'"
          :disabled="loading"
          :loading="loading"
          boton="Validar"
          titulo="VALIDAR LISTA DE PAGO"
          @si="validar"
        />

        <!-- <v-btn color="warning" v-if="pago.estado == 'Validado'" @click="cerrar">Cerrar</v-btn> -->
        <Confirmar
          v-if="pago.estado == 'Validado'"
          boton="Cerrar PAGO"
          :disabled="loading"
          :loading="loading"
          titulo="CERRAR LISTA DE PAGO"
          @si="cerrar"
        />
      </v-card-actions>
      <span class="red--text">{{ errorMessage }}</span>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import ConfirmarDescripcion from "./ConfirmarDescripcion.vue";
import AgregarDetalle from "./AgregarDetalle.vue";
// import ActualizarCelular from "./ActualizarCelular.vue";
import ActualizarMonto from "./ActualizarMonto.vue";
// import ActualizarCedula from "./ActualizarCedula.vue";
// import ActualizarCuenta from "./ActualizarCuenta.vue";
import ActualizarFactura from "./ActualizarFactura.vue";
import numeral from "numeral";
import Confirmar from "./Confirmar.vue";

export default {
  data() {
    return {
      pago: null,
      errorMessage: "",
      loading: false
    };
  },
  computed: {
    total() {
      if (this.pago && this.pago.pagosDetalle) {
        return this.pago.pagosDetalle.reduce((a, b) => {
          if (b.estado !== "Anulado") {
            return a + b.monto;
          } else {
            return a;
          }
        }, 0);
      }
      return 0;
    },
  },
  methods: {
    agregarDetalle(det) {

      console.log('cesar',det)

      this.errorMessage = "";

      if (this.pago.medioPago.montoLimite) {
        if (det.monto > this.pago.medioPago.montoLimite) {
          det.monto = this.pago.medioPago.montoLimite;
        }
      }

      // let cuenta = null;

      // //Agregamos la cuenta, si es zimple usamos el celular por omision

      // if (det.numeroCuenta) {
      //   cuenta = det.numeroCuenta;
      // } else {
      //   if (this.pago.medioPago.id == 1 && det.celularBeneficiario != null) {
      //     //zimple
      //     cuenta = det.celularBeneficiario;
      //   }
      // }

      


      axios
        .put("/pago/agregarDetalle", {
          monto: det.monto,
          cuenta: det.numeroCuenta,
          numeroDocumentoCuenta: det.numeroDocumentoCuenta,
          tipoDocumentoCuenta: det.tipoDocumentoCuenta,
          nombreTitularCuenta: det.nombreTitularCuenta,
          ordenPago: {
            id: det.ordenPagoId,
          },
          pago: {
            id: this.pago.id,
          },
          factura: { id: det.facturaId},
          banco: { id: det.bancoId },
        })
        .then((response) => {
          if (response.status !== 200) {
            return;
          }

          this.pago.pagosDetalle.push(response.data);

          setTimeout(() => {
            this.$refs.contenido.scrollTop = this.$refs.contenido.scrollHeight;
          }, 100);
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = err.response.data;
        });
    },
    agregarDetalleMasivo(filas) {
      this.errorMessage = "";

      this.loading = true;

      const pagosData = filas.map(f => {

        return {
          monto: f.monto,
          cuenta: f.numeroCuenta,
          banco: {id: f.bancoId},
          numeroDocumentoCuenta: f.numeroDocumentoCuenta,
          tipoDocumentoCuenta: f.tipoDocumentoCuenta,
          nombreTitularCuenta: f.nombreTitularCuenta,
          ordenPago: {
            id: f.ordenPagoId,
          },
          pago: {
            id: this.pago.id,
          },
          factura: { id: f.facturaId},
        }
      });



      axios
        .put("/pago/agregarDetalleMasivo", pagosData)
        .then((response) => {

          this.loading = false;

          if (response.status !== 200) {
            return;
          }

          response.data.forEach(p => {
            this.pago.pagosDetalle.push(p);
          })

          setTimeout(() => {
            this.$refs.contenido.scrollTop = this.$refs.contenido.scrollHeight;
          }, 100);
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.errorMessage = err.response.data;
        });
    },
    eliminarDetalle(id) {
      this.errorMessage = "";

      axios
        .delete(`/pago/eliminarDetalle/${id}`)
        .then((response) => {
          console.log(response);

          if (response.status !== 200) {
            return;
          }

          this.pago.pagosDetalle = this.pago.pagosDetalle.filter((row) => {
            return row.id != id;
          });
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          if (err && err.response && err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
    },
    async validar() {

      this.loading = true;
      

      this.errorMessage = "";
      await axios
        .post(`/pago/${this.pago.id}/validar`)
        .then((response) => {
          if (response.status !== 200) {
            window.alert("error" + response.statusText);
          }

          this.pago.estado = "Validado";
        })
        .catch((err) => {
          this.loading = false;
          if (err && err.response && err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });

        this.loading = false;
    },
    anular(anulacion) {
      this.errorMessage = "";
      axios
        .patch(`/pago/anularDetalle`, {
          id: anulacion.id,
          descripcion: anulacion.descripcion,
        })
        .then((response) => {
          if (response.status !== 200) {
            window.alert("error" + response.statusText);
          }

          this.pago.pagosDetalle.forEach((det) => {
            if (det.id == anulacion.id) {
              det.estado = "Anulado";
              return;
            }
          });
        })
        .catch((err) => {
          console.log(err);
          if (err && err.response && err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
    },
    async cerrar() {
      this.loading = true;
      await axios
        .post(`/pago/${this.pago.id}/cerrar`)
        .then((response) => {
          console.log(response);

          if (response.status !== 200) {
            window.alert("error" + response.statusText);
          }

          this.pago.estado = "Cerrado";
        })
        .catch((err) => {
          this.loading = false;
          if (err && err.response && err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });

        this.loading = true;
    },
    nuevoCelular(dato) {
      this.pago.pagosDetalle.forEach((pago) => {
        if (pago.ordenPago.beneficiario.id == dato.id) {
          pago.ordenPago.beneficiario.celular = dato.nuevoCelular;
          return;
        }
      });
    },
    nuevaCedula(dato) {
      this.pago.pagosDetalle.forEach((pago) => {
        if (pago.ordenPago.beneficiario.id == dato.id) {
          pago.ordenPago.beneficiario.cedula = dato.nuevaCedula;
          return;
        }
      });
    },
    nuevoMonto(dato) {
      this.pago.pagosDetalle.forEach((pago) => {
        if (pago.id == dato.id) {
          pago.monto = +dato.nuevoMonto;
          return;
        }
      });
    },
    nuevaCuenta(dato) {
      this.pago.pagosDetalle.forEach((pago) => {
        if (pago.id == dato.id) {
          pago.cuenta = dato.nuevaCuenta;
          return;
        }
      });
    },
    nuevaFactura(dato) {
      console.log("evento desde nuevaFactura");
      console.log(dato);
      this.pago.pagosDetalle.forEach((pago) => {
        if (pago.id == dato.pagoDetalleId) {
          console.log('encontrado')
          pago.factura = {id: dato.facturaId, numeroFactura: dato.numeroFactura, montoFactura: dato.montoFactura}
          // pago.factura.numeroFactura = dato.numeroFactura;
          return;
        }
      });
    },
    volver() {
      this.$router.push({ path: "/pago" });
    },
    ordenarDetalle(det) {
      return det.sort((a, b) => a.id - b.id);
      // let d =  det.sort((a,b) => {
      //   if (a.id > b.id) {
      //     return -1
      //   } else {
      //     return 1
      //   }
      // });

      // return d;
    },
  },
  components: {
    ConfirmarDescripcion,
    AgregarDetalle,
    // ActualizarCelular,
    // ActualizarCedula,
    // ActualizarCuenta,
    ActualizarMonto,
    ActualizarFactura,
    Confirmar,
  },
  mounted() {
    if (!numeral.locale) {
      numeral.register("locale", "es", {
        delimiters: {
          thousands: ".",
          decimal: ",",
        },
        currency: {
          symbol: "GPY",
        },
      });

      numeral.locale("es");
    }

    if (this.$route.params.id) {
      axios
        .get(`/pago/${this.$route.params.id}`)
        .then((response) => {
          let pago = response.data;
          axios
            .get(`/pago/detalle/${this.$route.params.id}`)
            .then((response) => {
              console.log("****", response.data);

              this.pago = { ...pago, pagosDetalle: response.data };

              if (this.pago.pagosDetalle) {
                this.pago.pagosDetalle = this.ordenarDetalle(
                  this.pago.pagosDetalle
                );
              }
            })
            .catch((err) => {
              console.log(err);
              this.errorMessage = "Error en la consulta";
            });
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    }
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY hh:mm");
      }
    },
    numberFormat(value) {
      if (value) {
        return numeral(value).format("#,##0"); // displaying other groupings/separators is possible, look at the docs
      }
    },
  },
};
</script>

<style scoped>
.v-chip.Pendiente {
  background: lightgreen;
}

.v-chip.Anulado {
  background: lightcoral;
}
</style>
